import "features/games/components/Games.scss";
import BackBar from "components/ui/BackBar/BackBar";
import Game from "features/games/components/Game";
import { useTitle } from "hooks/useTitle";

function GameDetail({ title, gameId = null }) {
  useTitle(title);

  return (
    <>
      <BackBar label={ 'Andere puzzels' } path={ `/doe-mee/spelletjes` }/>

      <div className="wrapper--fluid grid">
        <div className="content content--wide content--background content--games">
          <Game id={ gameId }/>
        </div>
      </div>
    </>
  )
}

export default GameDetail;
